IREP.master = (function () {
    var primaryNavBar, secondaryNavBar, notificationBar, navBar, secondaryNavElements, paddingDirection;
    var showNotify = false;
    var showSurvey = false;
    var keepFlashing = true;
    
    var contactUsOpen = false;
    
    var toggleSelectedNew = function (selected) {
        var navigationClass = selected.data("navigationClass");
        var navigation = secondaryNavBar.find("." + navigationClass);

        secondaryNavBar.find(".secondaryNav").removeClass("opened");

        var centeredNavLink = IREP.options.isRTL ? $(window).width() - (selected.position().left + selected.width()) : selected.position().left + 10;
        navigation.css(IREP.options.isRTL ? "paddingRight" : "paddingLeft", centeredNavLink);

        if (!secondaryNavBar.hasClass("opened")) {
            navigation.show();
            new TimelineLite()
                .to(secondaryNavBar, 0.25, {
                    top: (showNotify | showSurvey ? '101px' : '51px'),
                    onComplete: function () {
                    }
                })
                .to(navigation, 0.25, {
                    opacity: 1
                });
            secondaryNavBar.addClass("opened");
        } else {
            new TimelineLite()
                .to('.secondaryNav', 0.25, {
                    opacity: 0,
                    onComplete: function () {
                        $('.secondaryNav').hide();
                        navigation.show();
                    }
                })
                .to(navigation, 0.25, {
                    opacity: 1
                });
        }

        secondaryNavBar.find("." + navigationClass).addClass("opened");
    };

    var footerWaypoint = function () {
        //var footer = $("#footer");
        //footer.find('#unfix').waypoint(function (direction) {

        //    if (direction === 'down') {
        //        footer.find("#die_border").css({ "position": "static" });
        //    }

        //    if (direction === 'up') {
        //        footer.find("#die_border").css({ "position": "fixed" });
        //    }

        //}, { offset: 'bottom-in-view' });
    };


    var hideSecondaryNavBar = function () {
        new TimelineLite().to(secondaryNavBar, 0.25, { top: "-56px" });
        secondaryNavBar.removeClass("opened");
        secondaryNavBar.find(".secondaryNav").removeClass("opened");
        $('.secondaryNav').hide();
    };

    var showNotificationBar = function () {
        showNotify = notificationBar.is(':hidden');
        if (showNotify) {

            notificationBar.css('top', "-50px");
            notificationBar.css('display', 'table');
            notificationBar.animate({ top: "0px" }, 1000);
            $("#contentContainer").animate({ 'padding-top': "50px" }, 1000);
            navBar.animate({ top: "50px" }, 1000, function () {
                flashImage("accountSummaryimg");
            });
        }
    };

    var showSurveyBar = function () {
        showSurvey = $("#quickSurveyBar").is(':hidden');
        if (showSurvey) {

            $("#quickSurveyBar").css('top', "-50px");
            $("#quickSurveyBar").css('display', 'table');
            $("#quickSurveyBar").animate({ top: "0px" }, 1000);
            navBar.animate({ top: $("#quickSurveyBar").height() + "px" }, 1000);
           // $("#contentContainer").animate({ 'padding-top': $("#quickSurveyBar").height() + "px" }, 1000);
            $("#header").animate({ 'padding-top': $("#quickSurveyBar").height() + "px" }, 1000);
            if ($("#quickSurveyBarDiv").html().length <= 130) {
                $("#quickSurveyBarDiv").css("padding-top", "10px");
            }
        }
    };

    var hideNotificationBar = function () {
        keepFlashing = false;
        
        notificationBar.animate({ top: "-50px" }, 1000, function () {
            notificationBar.css('display', 'none');
            notificationBar.css('top', "0px");
        });

        $("#contentContainer").animate({ 'padding-top': "0px" }, 1000);
        navBar.animate({ top: "0px" }, 1000);
    };

    var hideSurveyBar = function () {
        $("#quickSurveyBar").animate({ top: "-50px" }, 1000, function () {
            $("#quickSurveyBar").css('display', 'none');
            $("#quickSurveyBar").css('top', "0px");
        });

        $("#contentContainer").animate({ 'padding-top': "0px" }, 1000);
        navBar.animate({ top: "0px" }, 1000);

        showSurvey = false;
    };

    var quickSurveyContinueHandler = function () {
        //Send opted-in to server
        var focusGroupId = $("#quickSurveyBarDiv").attr('data-focusGroupId');
        IREP.callApi("/promotion/focusgroup/insertparticipate", "POST", { FocusGroupId: focusGroupId } );
        //Redirect to survey
        IREP.redirect(IREP.generateSiteLink("/survey"));
        return false;
    }

    var quickSurveyNoThanksHandler = function () {
        //Send opted-out to survey
        var focusGroupId = $("#quickSurveyBarDiv").attr('data-focusGroupId');
        IREP.callApi("/promotion/focusgroup/insertoptout", "POST", { FocusGroupId: focusGroupId });

        //Close bar. 
        hideSurveyBar();
    }

    var returnFalse = function () {
    	return false;
    }

    var setFooterPosition = function () {
        var footer = $("#footer");
        var isFixed = footer.hasClass("fixed");
        var winHeight = $(window).height();
        var docHeight = $(document).height();
        var isTolerated = false;
        if (Math.abs(docHeight - winHeight) <= 4) {
            isTolerated = true;
        }

        if (isTolerated && !isFixed) {
            footer.addClass("fixed");
        } else if (!isTolerated && isFixed) {
            footer.removeAttr("class");
            footerWaypoint();
        }

        footer.fadeIn();
    };

    var init = function () {
        primaryNavBar = $("#primaryNavBar");
        secondaryNavBar = $("#secondaryNavBar");
        notificationBar = $("#notificationBar");
        navBar = $("#navbar");
        secondaryNavElements = secondaryNavBar.find(".secondaryNav");
        paddingDirection = IREP.options.isRTL ? "paddingRight" : "paddingLeft";

        var primaryTimeout;
        var timeoutid;

        var primaryClickHandler = function (e) {
            // see if there even is any secondary navigation links.
            var navigationClass = $(this).parent().data("navigationClass");
            if (secondaryNavBar.find("." + navigationClass).find("ul").length === 0) {

            } else {
                primaryNavBar.find(".navbutton a").on("click", primaryClickHandler);
                
                toggleSelectedNew($(this).parent());

                var self = this;
                clearTimeout(primaryTimeout);

                e.stopImmediatePropagation();
                e.preventDefault();

                setTimeout(function () {
                    $(self).off("click");
                }, 16);
            }
        };

        showNotificationBar();
        showSurveyBar();

        $(window).resizeDebounce({
            onResizeEnd: setFooterPosition,
            runOnStart: true,
            timeoutDelay: 100
        });

        $("#quickSurveyContinue").on("click", quickSurveyContinueHandler);
        $("#quickSurveyNoThanks").on("click", quickSurveyNoThanksHandler);

        $(document).on("click", function () {
            primaryNavBar.find(".navbutton a").off("click").on("click", primaryClickHandler);
            hideSecondaryNavBar();
        });
        $(document).on("scroll", function () {
            primaryNavBar.find(".navbutton a").off("click").on("click", primaryClickHandler);
            hideSecondaryNavBar();
        });
        secondaryNavBar.on("mouseleave", function () {
            primaryNavBar.find(".navbutton a").off("click").on("click", primaryClickHandler);
            timeoutid = setTimeout(function () {
                hideSecondaryNavBar();
            }, 500);
        });

        // by default links don't go anywhere until after the mouse has entered the element.
        primaryNavBar.find(".navbutton a").on("click", primaryClickHandler);


        primaryNavBar.find(".navbutton a").on("mouseout", function () {
            clearTimeout(primaryTimeout);
        });

        primaryNavBar.find(".navbutton a").on("mouseenter", function () {
            var self = this;
            var navigationClass = $(self).parent().data("navigationClass");
            if (secondaryNavBar.find("." + navigationClass).find("ul").length === 0) {
                primaryTimeout = setTimeout(function () {
                    hideSecondaryNavBar();
                }, 250);
            } else {
                primaryTimeout = setTimeout(function () {
                    toggleSelectedNew($(self).parent());

                    primaryNavBar.find(".navbutton a").off("click").on("click", primaryClickHandler);

                    setTimeout(function () {
                        $(self).off("click");
                    }, 16);

                    clearTimeout(timeoutid);
                }, 250);
            }
        }); 

        secondaryNavBar.on("mouseenter", function () {
            clearTimeout(timeoutid);
        });

        var accountDropOpen = false;
        $("#myAccount, .toggleDropDown").on("click", function () {
            if (showNotify) {
                //IREP.callApi("/home/viewed", "GET", { Popid: 10, participantId: 384764 }, function (data) {
                showNotify = false; 
                hideNotificationBar();
                //});
            }
            
            $("#accountDrop").slideToggle(600);

        });

        //$("#aContactUs, #divContactUs, #contactUsLink").on("click", function () {
        //    contactUsToggle();
        //    return false;
        //});

        footerWaypoint();

        var moveLeft = 0;
        var moveDown = 0;

        $(document).on({
            mouseenter: function (e) {
                var partId = $(this).attr("data-participantid");
                if (partId != "") {
                    IREP.callApi("participant/userpopupsummary", "GET", { allowfriends: partId }).done(function (data) {
                        // console.log(data);
                        if ($(".UserPopup[data-participantid='" + partId + "']:hover").length != 0) {

                            var pi = data.participantInfo;
                            var badges = data.badges.sort(function (a, b) {
                                a = new Date(a.earnedDate);
                                b = new Date(b.earnedDate);
                                return a > b ? -1 : a < b ? 1 : 0;
                            });
                            $(".popboxData").empty();
                            $("#popboxName").html(pi.firstName + " " + pi.lastName.substring(0, 1) + ".");
                            $("#popboxTier").html(data.tierName == "" ? "Bronze" : data.tierName);
                            $("#popboxTierBadge").append("<img class='tierBadge' src='" + IREP.options.appUrl + data.tierIcon + "' />");
                            $("#popboxLocation").html(pi.location);
                            if (pi.tier == 99 ) {
                                $("#popboxCompany").html("Intel");
                                $(".hideAdmin").hide();
                            } else {
                                $(".hideAdmin").show();
                                $("#popboxCompany").html(pi.storeChain);
                                $("#popboxMemberSince").html(moment(pi.enrolledDate).format('MMMM YYYY'));
                                $("#popboxNetworkMembers").html(data.edgeNetworkMemberCount);
                                $("#popboxLearnings").html(data.completedLearnings);
                                if (data.badges.length > 0) {
                                    $("#badgeCount").show();
                                    $("#popboxBadges").html(data.badges.length);
                                    var i = 0;
                                    $.each(data.badges, function (index, value) {
                                        if (i < 16) {
                                            $("#popboxBadgeList").show().append("<div class='miniBadgeWrapper'><img class='miniBadge' src='" + value.colorImageURL + "' /></div>");
                                            i++;
                                        } else {
                                            return;
                                        }
                                    });
                                } else {
                                    $("#popboxBadgeList").hide();
                                    $("#badgeCount").hide();
                                }
                            }
                   
                            moveDown = ($('#UserPopupBox').outerHeight() / 2);
                            moveLeft = 100;

                            var target = '#UserPopupBox';

                            var leftD = e.pageX + parseInt(moveLeft);
                            var maxRight = leftD + $(target).outerWidth();
                            var windowLeft = $(window).width() - 40;
                            var windowRight = 0;
                            var maxLeft = e.pageX - (parseInt(moveLeft) + $(target).outerWidth());


                            if (maxRight > windowLeft && maxLeft > windowRight) {
                                leftD = maxLeft;
                            }

                            var topD = e.pageY - parseInt(moveDown);
                            var maxBottom = parseInt(e.pageY + parseInt(moveDown) + 20);
                            var windowBottom = parseInt(parseInt($(document).scrollTop()) + parseInt($(window).height()));
                            var maxTop = topD;
                            var windowTop = parseInt($(document).scrollTop());
                            if (maxBottom > windowBottom) {
                                topD = windowBottom - $(target).outerHeight() - 20;
                            } else if (maxTop < windowTop) {
                                topD = windowTop + 20;
                            }
                    
                            $(target).css('top', topD).css('left', leftD);

                            $('#UserPopupBox').show();
                        }
                    });
                }
            },
            mouseleave: function () {
                $("#UserPopupBox").hide();
                $(".popboxData").empty();
            }
        },
        ".UserPopup");


    };

    function flashImage(img) {
        var randSeconds = 1
        var randDelay = randSeconds * 1000;
        var speed = 1000; // transition speed going form opacity 1 to 0.5 or 0.2 to 5
        var $img = $('#' + img);
        if (keepFlashing) {
            $img.delay(randDelay).animate({ 'opacity': .5 }, speed, function () {
                $img.animate({ 'opacity': 1 }, speed, flashImage(img));
            });
        }
        else {
            $img.animate({ 'opacity': 100 }, 0);
        }
    }
    var contactUsToggle = function () {
        $('#contactUs').css("display", "block");
        $("#contactUs").css("visibility", "visible");
        var height = IREP.contactus.getPopupHeight();
        TweenLite.to($('#contactUs'), 0.5, { bottom: (contactUsOpen ? '-=' + height : '+=' + height) });
        contactUsOpen = !contactUsOpen;
        IREP.contactus.clearMessage();//in case they come back to this to send multiple emails
    }
    
    var contactUsOpenStatus = function(status) {
        contactUsOpen = status;
    }

    return {
        init: init,
        contactUsToggle: contactUsToggle,
        contactUsOpenStatus: contactUsOpenStatus,
        setFooterPosition: setFooterPosition
    };
})();